import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import cn from 'clsx'
import type { TBadgeProps } from './Badge.types'
import styles from './Badge.module.css'

const badge = cva(styles.badge, {
    variants: {
        variant: {
            default: styles['badge-default'],
            location: styles['badge-location'],
            success: styles['badge-success'],
            error: styles['badge-error'],
            sale: styles['badge-sale'],
            top: styles['badge-top'],
            accent: styles['badge-accent'],
            subtle: styles['badge-subtle'],
            successSubtle: styles['badge-success-subtle'],
        },
        size: {
            m: undefined,
            s: styles['badge-size-s'],
        },
    },
    defaultVariants: { variant: 'default', size: 'm' },
})

export const Badge = forwardRef<HTMLSpanElement, TBadgeProps>(
    ({ className, children, Icon, variant = 'default', size = 'm', ...props }, ref) => (
        <span ref={ref} className={cn(badge({ variant, size }), className)} {...props}>
            {Icon ? <Icon className={styles.icon} /> : null}
            {children}
        </span>
    ),
)
